import fetchServer from "../fetchServer";

function findDisposableEmailMessage(detail) {
  if (!Array.isArray(detail)) return null;

  const stack = [...detail];

  while (stack.length) {
    const node = stack.pop();
    if (!node || typeof node !== "object") continue;

    const constraints = node.constraints || null;
    if (constraints && typeof constraints === "object") {
      const msg = constraints.IsNotDisposableEmailConstraint;
      if (typeof msg === "string" && msg.trim()) return msg;
    }

    if (Array.isArray(node.children) && node.children.length) {
      stack.push(...node.children);
    }
  }

  return null;
}

export default async function updateUsersProfile(id, data) {
  let result = { return: 0, msg: "Something went wrong updating profile!" };

  await fetchServer({
    method: "PATCH",
    url: "/main/v1/account/update/" + id + "?populate=detail",
    data,
  })
    .then((res) => {
      const payload = res?.data?.data || {};
      const code = payload?.code;
      const fallbackError = payload?.error || res?.data?.error || res?.message;

      if (res?.data && !payload?.error) {
        result = { return: 1, msg: "Successfull", data: payload };
        return;
      }

      if (code === 10) {
        const disposableMsg = findDisposableEmailMessage(payload?.detail);
        if (disposableMsg) {
          result.msg = disposableMsg;
          return;
        }
      }

      result.msg = fallbackError || result.msg;
    })
    .catch((err) => {
      console.log("Network Error!", err?.message || err);
    });

  return result;
}
